import igenoLogo from "./styles/images/igeno-logo.png"
import watercoolerLogo from "./styles/images/watercooler-logo.png"

const watercooler = {
  query: "Watercooler",
  logo : watercoolerLogo, 
  url : "watercooler.net/",
  links : [ { tag: "analytics", url : "tag/analytics"}, { tag: "dmo", url : "tag/dmo"}, { tag: "convention", url : "tag/convention/"}]
}

const igeno = {
  query: "Igeno",
  logo : igenoLogo, 
  url : "igeno.com/",
  links : [ { tag: "analytics", url : "tag/analytics"}, { tag: "mongodb", url : "tag/mongodb"}, { tag: "software", url : "tag/software"}]
}


export const api = igeno;



